export default "__VITE_ASSET__BfuES08w__"